import { apiBaseUrl } from "../../data/artemulkContent";
import { normalizeListingDetail } from "../../utils/normalizeListingDetail";
import { setCardDetail } from "../slice/cardDetailSlice";

export const fetchCardDetail = (id) => async (dispatch, getState) => {
  const cached = normalizeListingDetail(getState().cardDetail);

  try {
    const response = await fetch(`${apiBaseUrl}/advertDetailOffice/${id}`);
    if (!response.ok) {
      throw new Error("Kart detayı yüklenemedi.");
    }
    const data = await response.json();
    dispatch(setCardDetail(normalizeListingDetail(data)));
  } catch (error) {
    if (cached?.result?.id && String(cached.result.id) === String(id)) {
      dispatch(setCardDetail(cached));
      return;
    }
    console.error("İlan detayı hatası:", error);
    throw error;
  }
};
